// extracted by mini-css-extract-plugin
export default {"body":"support_body__T84f1","container":"support_container__CKb3d"};